var _path, _g, _path2, _g2, _path3, _path4, _path5, _g3, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 259,
    viewBox: "0 0 197 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.668 63.543L196.62 121.281L163.288 179.601L130.467 122.155L163.668 63.543Z",
    fill: "url(#paint0_linear_196_3359)",
    fillOpacity: 0.84
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_196_3359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6685 48.4553H81.6652C94.8293 48.8497 107.996 52.2906 119.363 59.0108C116.251 59.9176 113.024 60.3617 109.928 61.3337C103.742 62.9548 97.7329 65.1658 91.8325 67.613C87.8575 64.0479 82.249 62.2467 76.9729 63.3988C75.0754 63.6783 73.4202 64.6814 71.6314 65.2808C70.3489 64.6224 69.2495 63.669 68.0508 62.8771C64.9951 60.8151 61.8616 58.8649 58.6475 57.0575C56.5358 55.7873 54.2626 54.8029 52.1602 53.5172C60.2934 50.3745 68.9763 48.8218 77.6685 48.4553Z",
    fill: "url(#paint1_linear_196_3359)",
    fillOpacity: 0.16
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0803 61.6972C36.8194 61.2563 37.4901 60.6445 38.3224 60.3867C47.5053 64.017 56.1571 68.9112 64.2313 74.588C63.5202 77.1749 63.1258 79.9015 63.6196 82.5691C63.663 83.1467 64.0171 83.9324 63.3494 84.2895C56.8217 89.2862 50.7039 94.8295 45.1824 100.926C44.6886 101.394 44.17 102.217 43.3781 101.86C39.5397 100.863 35.4064 101.261 31.8227 102.95C26.3663 96.8449 21.4597 90.2396 17.3077 83.1778C16.8791 82.3952 16.258 81.6809 16.0469 80.8021C21.497 73.2993 28.3663 66.8399 36.0803 61.6972Z",
    fill: "url(#paint2_linear_196_3359)",
    fillOpacity: 0.84
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_196_3359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.128 78.2831C108.27 73.5255 120.124 70.4604 132.164 69.1623C132.81 69.0691 133.518 69.0505 133.962 69.6157C140.092 75.3018 145.347 81.9413 149.412 89.2516C155.806 100.602 159.209 113.558 159.48 126.567V129.641C159.324 132.784 159.07 135.921 158.706 139.048C151.685 141.122 144.471 142.551 137.188 143.327C136.794 143.383 136.307 143.38 136.164 142.923C135.223 141.135 134.164 139.38 132.67 137.995C129.63 134.924 125.378 133.265 121.096 133.088C116.028 117.707 108.227 103.226 98.0751 90.6087C97.2584 89.5621 96.3112 88.6118 95.6094 87.4846C95.6591 86.702 96.0597 86.0001 96.2926 85.2642C97.1155 83.0375 97.2553 80.6339 97.128 78.2831Z",
    fill: "url(#paint3_linear_196_3359)",
    fillOpacity: 0.16
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93666 92.373C10.5888 94.6121 11.9893 97.0281 13.6787 99.2423C16.7128 103.54 20.1132 107.556 23.5727 111.512C22.2156 114.881 21.8368 118.645 22.7374 122.182C23.1877 124.263 24.2125 126.148 25.346 127.928C25.7838 128.455 25.2807 129.08 25.082 129.598C18.6257 141.744 14.2129 154.93 11.6788 168.438C8.18824 162.87 5.64176 156.737 3.74432 150.455C1.71645 143.703 0.744434 136.679 0.480469 129.642V126.263C0.812754 114.534 3.59836 102.842 8.93666 92.373Z",
    fill: "url(#paint4_linear_196_3359)",
    fillOpacity: 0.84
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8366 108.965C58.8705 103.422 64.4045 98.3105 70.398 93.8169C71.3514 94.1026 72.1185 94.7889 73.0222 95.1895C76.9723 97.0838 81.6957 97.3975 85.8291 95.9131C86.2515 95.8417 86.8415 95.4317 87.1707 95.9007C97.2479 107.981 105.083 121.968 109.896 136.955C108.983 138.141 107.76 139.073 106.968 140.362C106.409 141.088 106.117 142.032 105.422 142.638C87.5402 140.026 70.3421 133.247 55.2868 123.278C56.5259 119.027 56.2154 114.285 54.0695 110.375C53.9173 109.919 53.2993 109.372 53.8366 108.965Z",
    fill: "url(#paint5_linear_196_3359)",
    fillOpacity: 0.84
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6455 134.79C39.8535 135.582 44.2943 134.824 47.9743 132.623C63.3339 142.967 80.7835 150.227 99.0064 153.578C99.8263 153.73 100.646 153.904 101.46 154.109C98.0189 156.178 94.342 157.836 91.0223 160.103C81.4605 165.985 72.7311 173.168 64.9177 181.217C62.2066 184.208 59.3962 187.117 56.9646 190.347C54.2287 193.577 51.884 197.101 49.4804 200.58C49.2879 200.806 49.114 201.272 48.7351 201.048C38.5864 196.766 29.4657 190.213 21.8945 182.236C23.1522 165.696 27.9781 149.485 35.6455 134.79Z",
    fill: "url(#paint6_linear_196_3359)",
    fillOpacity: 0.84
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_196_3359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.884 155.289C143.216 154.628 149.489 153.529 155.706 152.159C150.573 168.031 140.412 182.273 126.875 192.052C127.074 188.176 127.717 184.332 127.707 180.444C127.946 175.487 127.866 170.519 127.518 165.569C131.878 163.609 135.387 159.845 136.884 155.289Z",
    fill: "url(#paint7_linear_196_3359)",
    fillOpacity: 0.16
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.969 167.339C104.637 165.848 107.398 164.522 110.118 163.128C111.826 164.383 113.705 165.379 115.677 166.153C116.224 173.73 116.102 181.357 115.251 188.906C114.783 192.583 114.379 196.294 113.46 199.887C112.544 200.633 111.363 200.943 110.304 201.431C101.336 205.167 91.681 207.12 81.9826 207.455H78.2902C72.3681 207.257 66.4708 206.49 60.707 205.101C69.3992 192.456 80.4423 181.416 93.1654 172.829C95.9665 170.792 99.0161 169.14 101.969 167.339Z",
    fill: "url(#paint8_linear_196_3359)",
    fillOpacity: 0.84
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_196_3359",
    x: 30.0549,
    y: 26.3501,
    width: 111.413,
    height: 63.3682,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.0526
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3359"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3359",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_196_3359",
    x: 73.5041,
    y: 47.007,
    width: 108.081,
    height: 118.45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.0526
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3359"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3359",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_196_3359",
    x: 104.77,
    y: 130.054,
    width: 73.0416,
    height: 84.1033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.0526
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3359"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3359",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_3359",
    x1: 163.457,
    y1: 182.033,
    x2: 79.3858,
    y2: 90.9779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1735A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685839,
    stopColor: "#099B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_196_3359",
    x1: 121.49,
    y1: 65.4518,
    x2: 77.7916,
    y2: 22.4241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_196_3359",
    x1: 40.0758,
    y1: 103.842,
    x2: 16.4281,
    y2: 52.9744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1735A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685839,
    stopColor: "#099B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_196_3359",
    x1: 161.502,
    y1: 134.977,
    x2: 84.2112,
    y2: 116.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_196_3359",
    x1: 12.9673,
    y1: 170.032,
    x2: -36.7361,
    y2: 138.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1735A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685839,
    stopColor: "#099B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_196_3359",
    x1: 81.6849,
    y1: 143.661,
    x2: 54.877,
    y2: 84.9447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1735A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685839,
    stopColor: "#099B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_196_3359",
    x1: 61.5726,
    y1: 202.542,
    x2: 24.1611,
    y2: 119.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1735A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685839,
    stopColor: "#099B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_196_3359",
    x1: 156.619,
    y1: 187.552,
    x2: 121.155,
    y2: 180.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_196_3359",
    x1: 88.285,
    y1: 208.384,
    x2: 65.2134,
    y2: 153.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1735A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685839,
    stopColor: "#099B91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossChain);
export default __webpack_public_path__ + "static/media/cross-chain.3bb3641c834af44611653bf7ff6e087c.svg";
export { ForwardRef as ReactComponent };